module.exports = __webpack_public_path__ + "img/RCA_Identity-White.e015756d.png";